import { GLOBAL_TABBED_DRAWER } from "../consts";

const cancel = crm => ({ setDrawerOpen, getState }) => {

	setDrawerOpen(GLOBAL_TABBED_DRAWER, { isOpen: false });
};

export default cancel;
